import React from "react";
import CommunityEditPage from "../community/components/CommunityEditPage";
import { SHARE_WITH_NEIGHBORS } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function EditShareWithNeighborsPage() {
  useRequireSectionVisible("showShareWithNeighbors");
  return <CommunityEditPage section={SHARE_WITH_NEIGHBORS} />;
}
